import { SVGFC } from '@repo/toolkit/types'

const CheckMark3Icon: SVGFC = ({ color, ...props }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_1885_37126)">
        <path
          d="M12 2C6.48154 2 2 6.48154 2 12C2 17.5185 6.48154 22 12 22C17.5185 22 22 17.5185 22 12C22 6.48154 17.5185 2 12 2ZM12 2.77077C17.1023 2.77077 21.2308 6.89769 21.2308 12C21.2308 17.1023 17.1023 21.2308 12 21.2308C6.89769 21.2308 2.76923 17.1023 2.76923 12C2.76923 6.89769 6.89769 2.77077 12 2.77077ZM12.0015 6.99692C11.3445 6.99621 10.6937 7.12537 10.0867 7.37698C9.47975 7.62859 8.92848 7.9977 8.46462 8.46308C7.99959 8.92708 7.63065 9.47826 7.37892 10.085C7.12719 10.6918 6.99761 11.3423 6.99761 11.9992C6.99761 12.6562 7.12719 13.3066 7.37892 13.9134C7.63065 14.5202 7.99959 15.0714 8.46462 15.5354C8.92862 16.0004 9.4798 16.3694 10.0866 16.6211C10.6934 16.8728 11.3438 17.0024 12.0008 17.0024C12.6577 17.0024 13.3082 16.8728 13.915 16.6211C14.5217 16.3694 15.0729 16.0004 15.5369 15.5354C16.002 15.0714 16.3709 14.5202 16.6226 13.9134C16.8744 13.3066 17.0039 12.6562 17.0039 11.9992C17.0039 11.3423 16.8744 10.6918 16.6226 10.085C16.3709 9.47826 16.002 8.92708 15.5369 8.46308C15.0733 7.99775 14.5223 7.62866 13.9156 7.37704C13.3089 7.12542 12.6584 6.99624 12.0015 6.99692ZM14.2785 10.46H14.3185C14.6385 10.4646 14.7977 10.9677 14.5392 11.1554L11.4623 13.4631C11.3873 13.5159 11.2963 13.5412 11.2047 13.5346C11.1131 13.528 11.0267 13.49 10.96 13.4269L9.42154 11.8885C9.12769 11.6062 9.68308 11.05 9.96538 11.3446L11.2685 12.6477L14.0777 10.54C14.1361 10.4951 14.2059 10.4674 14.2792 10.46H14.2785Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_1885_37126">
          <rect width="20" height="20" fill={color} transform="translate(2 2)" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default CheckMark3Icon
